<template>
  <div class="middle-main">
    <div class="full-main">
      <img class="back-img" :src="`${assetsUrl}imgs/course/design-practice/sysjsjsxpt.jpg`" />
    </div>
    <div class="background-black" v-if="list && list.length == 0">
      <h2>{{ data.classesName || '商业视觉设计实训平台' }}</h2>
      <button class="orange-radius" @click="goEnterPractice()">{{ btnText || '进入学习' }}</button>
    </div>
    <div class="background-black" v-if="list && list.length > 0">
      <h2>选择课程</h2>
      <div class="button-flex">
        <button
          @click="goEnterPractice()"
          v-for="(course, index) of list"
          :key="index"
          class="orange-radius"
          target="_blank"
        >
          {{ course.name }}
        </button>
      </div>
    </div>
  </div></template
>

<script>
// import Vue from 'vue'
// import { getToken } from '../api'
export default {
  name: 'Addition',
  components: {},
  data() {
    return {
      btnText: '设计乐实训模考',
      assetsUrl: 'https://static.51lss.com/o2ostu/assets/',
      user: {},
      domain: [],
      domainData: [],
      classesIdSubjectIds: {
        // 商业设计师体验课
        e82e785c3273c223789c403ae4f1b84a: ['f0d7f54bc4d445daa202b84ee2e917a4'],
        // 商业设计师就业课
        '35c12617c3a4187028945a4239fa1076': [
          '13ae216497a54a92b86bedf9f36b544a',
          '41d5e971d9234657a9f024a15cf79481',
          'faa10dc0fc7444da896f753564b2f0f3'
        ]
      },
      list: []
    }
  },
  props: {
    planclassesId: {
      type: String,
      required: false,
      default: ''
    },
    classesId: {
      type: String,
      required: false,
      default: ''
    },
    data: {
      type: Object,
      required: false,
      default: null
    }
  },
  created() {},
  methods: {
    goEnterPractice() {
      window.open(this.data.classesUrls[0].url)
      // const userInfo = Vue.ls.get('USER_INFO')
      // getToken({
      //     grant_type: 'sso',
      //     userId: userInfo.id,
      //     telphone: userInfo.phoneNumber,
      //     fullName: userInfo.stuName,
      //     orgId: userInfo.orgId,
      //     subjectIds: this.data.courseType
      //   }).then(res => {
      //   console.log(res)
      //   const redictUrl = 'https://shejl.accfun.com//pracTrain/index?access_token=' + res.access_token
      //   window.open(redictUrl)
      // })
      // let subjectIds = this.classesIdSubjectIds[this.classesId] ? this.classesIdSubjectIds[this.classesId].join(',') : ''
      // this.http
      //   .postH(
      //     environment.sjlService + '/oauth/token',
      //     {
      //       grant_type: 'sso',
      //       userId: userInfo.stuId,
      //       telphone: userInfo.phoneNumber,
      //       fullName: userInfo.stuName,
      //       orgId: userInfo.orgId,
      //       subjectIds: this.data.courseType
      //     },
      //     false,
      //     false,
      //     false,
      //     { Authorization: 'Basic ZGV2OmRldg==' }
      //   )
      //   .subscribe(result => {
      //     const redictUrl = environment.sjlWebHost + '/pracTrain/index?access_token=' + result.access_token
      //     console.log(redictUrl)
      //     window.open(redictUrl)
      //   })
    }
  }
}
</script>
<style scoped lang="less">
.middle-main {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  position: relative;
}
.full-main {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
}
.back-img {
  height: 100%;
  max-width: 100%;
  display: inline-block;
}
.background-black {
  padding: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 2;
  h2 {
    color: #ffffff;
  }
}
.orange-radius {
  background-color: #ff9a2b;
  font-weight: bold;
  padding: 8px 40px;
  margin-top: 30px;
  font-size: 18px;
  border-radius: 35px;
  color: #ffffff;
  border: none;
  &:hover {
    transform: scale(1.1, 1.1);
  }
}

button:focus {
  outline: 0 !important;
}
</style>
